import React from 'react'
import Link from 'jl-design-system/elements/link/Link'
import { PrimaryButton } from 'jl-design-system/components/button/Button'
import requestNewLink from '../../../utils/auth0/requestNewLink'
import { getSignInUrl } from '../../../utils/errors'
import styles from './ResetPasswordLinkUsedError.scss'

type Props = {
  code: string
}

export default function ResetPasswordLinkUsedError({ code }: Props) {
  const signInUrl = getSignInUrl()

  return (
    <div data-testid="reset-password-link-used-error">
      <p className={styles.body} data-testid="error-body">
        Please request another link.
      </p>

      <div>
        <PrimaryButton
          onClick={() => requestNewLink(code)}
          className={styles.cta}
          data-testid="error-cta"
          labelText="Request another link"
          width="full-width"
        />
      </div>

      <div className={styles.signin}>
        <Link to={signInUrl} external data-testid="signin-link">
          Back to sign in
        </Link>
      </div>
    </div>
  )
}
